import React, { useRef, useState } from 'react'; // 🧠 Pindahkan useState ke sini
import { Mail, MapPin, Phone, Coffee } from 'lucide-react';
import { motion, useInView } from 'framer-motion';
import ReCAPTCHA from 'react-google-recaptcha';

const boxVariants = {
  hidden: { opacity: 0, y: 40, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.6, ease: 'easeOut' },
  },
};

const GetInTouch = () => {
  const [isVerified, setIsVerified] = useState(false); // ✅ Pindahkan ke sini
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const isLeftInView = useInView(leftRef, { once: true, amount: 0.4 });
  const isRightInView = useInView(rightRef, { once: true, amount: 0.4 });

  return (
    <section
      id="contact"
      className="min-h-screen py-20 px-6 md:px-20 bg-[#F5F3EF] text-[#4B4033]"
    >
      <h2 className="text-2xl font-bold mb-12 text-center text-[#5D5044]">
        Get In Touch With Me
      </h2>

      <div className="flex flex-col lg:flex-row items-stretch justify-center gap-10 max-w-6xl mx-auto">
        {/* Left Box */}
        <motion.div
          ref={leftRef}
          className="flex-1 flex flex-col justify-between bg-white bg-opacity-60 p-8 rounded-2xl border-2 border-[#D9CFC2] shadow-md"
          variants={boxVariants}
          initial="hidden"
          animate={isLeftInView ? 'visible' : 'hidden'}
        >
          <div className="flex flex-col gap-6">
            <div className="flex items-start gap-4">
              <Mail className="min-w-6 min-h-6 mt-1 text-[#8C6D5A]" />
              <div>
                <p className="text-lg font-semibold">Email</p>
                <p className="text-md text-[#6F6255]">hugowiratama21@gmail.com</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <MapPin className="min-w-6 min-h-6 mt-1 text-[#8C6D5A]" />
              <div>
                <p className="text-lg font-semibold">Location</p>
                <p className="text-md text-[#6F6255]">Bekasi, Indonesia</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <Phone className="min-w-6 min-h-6 mt-1 text-[#8C6D5A]" />
              <div>
                <p className="text-lg font-semibold">Phone</p>
                {isVerified ? (
                  <p className="text-md text-[#6F6255]">(+62) 81219456916</p>
                ) : (
                  <p className="text-md italic text-[#A09588]">Please verify captcha to see phone number</p>
                )}
              </div>
            </div>
            <ReCAPTCHA
              sitekey="6Lcup2ErAAAAAEQrjCSbxXYAHv6frbDxkTb_lmJZ"
              onChange={() => setIsVerified(true)}
              className="mt-6 self-center"
            />
          </div>

          <div className="flex justify-center mt-10">
            <motion.a
              href="https://saweria.co/hugowrtma"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.07 }}
              transition={{ type: 'spring', stiffness: 300 }}
              className="inline-flex items-center gap-3 px-6 py-3 bg-[#8C6D5A] hover:bg-[#7B5E4C] text-white font-semibold rounded"
            >
              <Coffee className="min-w-5 min-h-5" />
              Fuel my late-night coding, every bit helps!
            </motion.a>
          </div>
        </motion.div>

        {/* Right Box */}
        <motion.div
          ref={rightRef}
          className="flex-1 bg-white bg-opacity-60 p-8 rounded-2xl border-2 border-[#D9CFC2] shadow-md flex flex-col justify-between"
          variants={boxVariants}
          initial="hidden"
          animate={isRightInView ? 'visible' : 'hidden'}
        >
          <form
            action="https://formspree.io/f/xyzwebbv"
            method="POST"
            className="flex flex-col gap-6"
          >
            <input
              type="text"
              name="name"
              autocomplete="name"
              placeholder="Your Name"
              required
              className="bg-white bg-opacity-70 border border-[#D9CFC2] rounded px-4 py-3 text-[#4B4033] placeholder-[#8C6D5A] focus:outline-none focus:ring-2 focus:ring-[#8C6D5A]"
            />
            <input
              type="email"
              name="email"
              autocomplete="email"
              placeholder="Your Email"
              required
              className="bg-white bg-opacity-70 border border-[#D9CFC2] rounded px-4 py-3 text-[#4B4033] placeholder-[#8C6D5A] focus:outline-none focus:ring-2 focus:ring-[#8C6D5A]"
            />
            <textarea
              name="message"
              rows="5"
              placeholder="Your Message"
              required
              className="bg-white bg-opacity-70 border border-[#D9CFC2] rounded px-4 py-3 text-[#4B4033] placeholder-[#8C6D5A] focus:outline-none focus:ring-2 focus:ring-[#8C6D5A]"
            />

            <motion.button
              type="submit"
              whileHover={{ scale: 1.09 }}
              transition={{ type: 'spring', stiffness: 300 }}
              className="self-center bg-[#8C6D5A] hover:bg-[#7B5E4C] text-white font-semibold px-6 py-3 rounded"
            >
              Send Message
            </motion.button>
          </form>
        </motion.div>
      </div>
    </section>
  );
};

export default GetInTouch;
